import React, { useContext, useEffect, useRef, useState } from "react";
import DropDown from "../../../../../../components/SVGComponents/Tools/DropDown";
import KeyImage from "../../../../../../components/SVGComponents/Tools/KeyImage";
import {
  DirectionalHint,
  Modal,
  TextField,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import ViewportContext from "../../../../../../context/studyviewer/ViewportContext";
import studyviewerContext from "../../../../../../context/studyviewer/StudyviewerContext";
import {
  isKeyImageAlreadyPresent,
  maxKeyImageValidation,
} from "../../../../helpers/KeyImageUtility";
import DialogBox from "../../../../../../components/Modal/DialogBox";
import { useTranslation } from "react-i18next";
import ModalHeader from "../../../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../../../components/Modal/ModalFooter";
import { getViewport } from "../../../../helpers/CornerstoneViewportService";
import ATextField from "../../../../../../components/ATextField";
import { KeyImageSchema } from "../../../../../../Schemas/KeyImageSchema";
import { useFormik } from "formik";
import KeyImageInputModal from "./KeyImageInputModal";
import ManageKeyImageModal from "./ManageKeyImageModal";
import AdvKeyImagesModal from "../../../AdvKeyImagesModal/AdvKeyImagesModal";
import themeContext from "../../../../../../context/theme/ThemeContext";
import {
  toolBarFlex,
  toolStyle,
  toolTipStyles,
} from "../../../../styles/styles";
import studyReportContext from "../../../../../../context/studyreport/StudyReportContext";
import CustomToolTipHost from "../../../../../../components/CustomToolTipHost/CustomToolTipHost";
import { isMobile } from "react-device-detect";
import { HIDE_TOOL_SMALL_SCREEN } from "../../../../../../constants/Constants";

const KeyImages = () => {
  const { t } = useTranslation();
  const { theme } = useContext(themeContext);
  const [hoverManage, setHoverManage] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const [showDialogBox, setShowDialogBox] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [showInputKeyImageModal, setShowInputKeyImageModal] = useState(false);
  const [showManageKeyImageModal, setShowManageKeyImageModal] = useState(false);
  // const [inputKeyImageTitle, setInputKeyImageTitle] = useState("");
  const { activeViewportIndex } = useContext(ViewportContext);
  const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);
  const {
    savedKeyImages,
    setSavedKeyImages,
    unsavedKeyImages,
    setUnsavedKeyImages,
    keyImages,
    setKeyImages,
    studyParentId,
  } = useContext(studyviewerContext);
  const dropDownRef = useRef(null);
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleKeyImageClick = async () => {
    console.log(" --------- PASSWORD -------- ");
    // console.log(encrypt("Admin@123"));
    // console.log(decrypt("$2a$10$UTLKW3jS776i9d4VrViHhOkHUBwsC3utrTjVOzttnIez2sszFKH7y"));

    const activeViewport = await getViewport(activeViewportIndex);
    console.log(keyImages);
    let keyImagePresent = isKeyImageAlreadyPresent(activeViewport, keyImages);
    console.log(keyImagePresent);
    if (keyImagePresent) {
      // setShowDialogBox(true);
      // setDialogMessage(t("key-image.already-exists"));
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("key-image.already-exists");
        return newItem;
      });
      return;
    }

    if (!maxKeyImageValidation(keyImages)) {
      //setShowDialogBox(true);
      //setDialogMessage(t("key-image.maximum-key"));
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("key-image.maximum-key");
        return newItem;
      });
      return;
    }
    setShowInputKeyImageModal(true);
  };

  return (
    <>
      {isMobile ? (
        <>
          <div
            onClick={() => setShowManageKeyImageModal(prev => !prev)}
            style={toolStyle}
          >
            <>
              <div
                style={{
                  height: "65%",
                  width: "60px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className={
                    isMobile ? "highlight-tool-mobile" : "highlight-tool"
                  }
                >
                  <KeyImage
                    color={
                      hovered
                        ? theme.palette.activeTool
                        : theme.palette.inactiveTool
                    }
                  />
                </div>
              </div>
              <span
                style={{
                  fontSize: "9px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  //color: "#FFFFFF",
                  //color: "var(--navbar-header-popup-color-txt)",
                  color: "var(--mobile-color-txt)",
                }}
              >
                {"Key Images"}
              </span>
            </>
          </div>
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <CustomToolTipHost
            delay={TooltipDelay.zero}
            id={"key-image"}
            directionalHint={DirectionalHint.rightCenter}
            styles={toolTipStyles}
            content={t("viewer.tools.key-images")}
            className={"myToolTip"}
          >
            <div
              className="highlight-tool"
              style={{
                width: "45px",
              }}
            >
              <div
                style={toolBarFlex}
                onMouseOver={handleMouseOver}
                onMouseLeave={handleMouseLeave}
                onClick={handleKeyImageClick}
              >
                <KeyImage
                  color={
                    hovered
                      ? theme.palette.activeTool
                      : theme.palette.inactiveTool
                  }
                />
              </div>
              <div
                style={{
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
                onClick={() => setShowDropDown(!showDropDown)}
                onMouseOver={() => setDropDownHovered(true)}
                onMouseLeave={() => setDropDownHovered(false)}
              >
                <DropDown
                  color={
                    dropDownHovered || hovered
                      ? theme.palette.activeTool
                      : theme.palette.inactiveTool
                  }
                />
              </div>
            </div>
          </CustomToolTipHost>
          <div
            onClick={() => (
              setShowManageKeyImageModal(true), setShowDropDown(false)
            )}
            onMouseOver={() => setHoverManage(true)}
            onMouseLeave={() => setHoverManage(false)}
            ref={dropDownRef}
            className="viewer-tool-more-dropdown"
            style={{
              display: `${showDropDown ? "flex" : "none"}`,
              // backgroundColor: "#201F1E",
              boxShadow:
                "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
              borderRadius: "5px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              top: window.innerHeight * 0.075,
              zIndex: "999",
              height: "40px",
              width: "150px",
            }}
          >
            <span
              style={{
                color: `${
                  hoverManage
                    ? theme.palette.activeTool
                    : theme.palette.inactiveTool
                }`,
              }}
            >
              {t("key-image.manage-key-image")}
            </span>
          </div>
        </div>
      )}
      <DialogBox
        setShowDialogBox={setShowDialogBox}
        showDialogBox={showDialogBox}
        title={t("key-image.alert")}
        message={dialogMessage}
        confirmButtonText={t("key-image.ok")}
      />
      {showInputKeyImageModal && (
        <KeyImageInputModal
          showInputKeyImageModal={showInputKeyImageModal}
          setShowInputKeyImageModal={setShowInputKeyImageModal}
          setShowDialogBox={setShowDialogBox}
          setDialogMessage={setDialogMessage}
        />
      )}
      {showManageKeyImageModal &&
        (isMobile ? (
          // NEW: mobile uses the advanced key-image modal (same as desktop TopBar/AdvTopBar),
          // which fetches saved key images from the backend by studyId.
          <AdvKeyImagesModal
            showManageAdvKeyImagesModal={showManageKeyImageModal}
            setShowManageAdvKeyImagesModal={setShowManageKeyImageModal}
            studyId={studyParentId}
          />
        ) : (
          // OLD: legacy modal that reads the (empty) keyImages context. Kept for the
          // non-mobile path, though KeyImages itself is currently only mounted on mobile.
          <ManageKeyImageModal
            showManageKeyImageModal={showManageKeyImageModal}
            setShowManageKeyImageModal={setShowManageKeyImageModal}
            setShowDialogBox={setShowDialogBox}
            setDialogMessage={setDialogMessage}
          />
        ))}
    </>
  );
};

export default KeyImages;
